import mbxClient from '@mapbox/mapbox-sdk';
import geocoding from '@mapbox/mapbox-sdk/services/geocoding';

// const baseClient = mbxClient({ accessToken: 'pk.eyJ1IjoiZG5sc2FsYXphciIsImEiOiJjazlhanAzMGgwNmZoM2ZxcjFubmZyNDQ5In0.vWx_BcKUVet4mGXu6dcexA' });
const baseClient = mbxClient({ accessToken: 'pk.eyJ1IjoibWFyc2hhbGxtdXJwaHoiLCJhIjoiY2xvdzVmOHhzMHZ6ODJpcWdsYnJlbjhrdyJ9.KSJzvrCTWwTcqdnjDv3HnQ' });
export const geocodingService = geocoding(baseClient);

export const getDirectionFromPoint = async (newLngLt) => {
  try {
    const response = await geocodingService.reverseGeocode({
      query: [newLngLt.lng, newLngLt.lat],
      countries: ['US'],
    }).send();
    if (!response) return null;
    if (response.features) return null;
    const { features } = response.body;
    let place = {};
    features.forEach(element => {
      const { text } = element;
      const place_type = element.place_type[0];
      //console.log('element', place_type)
      switch (place_type) {
        case 'address': {
          place[place_type] = (element.address ? element.address + ' ' : '') + text;
          break;
        }

        case 'postcode': {
          place['zipcode'] = text;
          break;
        }

        case 'place': {
          place['city'] = text;
          break;
        }

        case 'region': {
          place['state'] = text;
          break;
        }

        case 'neighborhood': {
          place['neighborhood'] = text;
          break;
        }

        default: {
          place[place_type] = text;
          break;
        }
      }
    });
    return place;
  } catch (err) {
    throw err;
  }
}


export const getPointsFromDirection = async (address) => {
  try {
    const response = await geocodingService.forwardGeocode({
      query: (address.address ? address.address + ', ' : '') +
        (address.city ? address.city.toLowerCase() + ', ' : '') +
        (address.state ? address.state.toLowerCase() + ', ' : '') +
        (address.zipcode ? address.zipcode + ', ' : '') +
        'US',
      limit: 1
    }).send();
    if (!response) return null;
    if (response.features) return null;
    const { features } = response.body;
    let latlng = {};   
    features.forEach(element => {
      // const { text } = element;
      const place_type = element.geometry.coordinates;
      //console.log(place_type) setCoors(() => newLngLt);
      latlng = { 'latitude': place_type[1], 'longitude': place_type[0] }
    });
    return latlng;
  } catch (err) {
    throw err;
  }
}